<div class="overflow-y-auto flex flex-col gap-2 flex-1">
    @if (loading()) {
        <div class="bg-[var(--table-row-bg,var(--base-2))] rounded-md h-24 animate-pulse"></div>
        <div class="bg-[var(--table-row-bg,var(--base-2))] rounded-md h-24 animate-pulse opacity-90"></div>
        <div class="bg-[var(--table-row-bg,var(--base-2))] rounded-md h-24 animate-pulse opacity-80"></div>
        <div class="bg-[var(--table-row-bg,var(--base-2))] rounded-md h-24 animate-pulse opacity-70"></div>
        <div class="bg-[var(--table-row-bg,var(--base-2))] rounded-md h-24 animate-pulse opacity-60"></div>
    } @else if (totalItems() === 0) {
        <div class="flex-1 flex items-center justify-center">
            <span class="text-shui-ui-6">No items to display.</span>
        </div>
    } @else {
        <ng-content></ng-content>
    }
</div>
<app-paginator
    class="mt-2"
    [pageSize]="pageSize()"
    [currentPage]="currentPage()"
    [totalItems]="totalItems()"
    (pageChange)="pageChange.emit($event)"
    (pageSizeChange)="pageSizeChange.emit($event)"
></app-paginator>
